import { Box } from '@mui/material'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Panel from 'components/Panel'
import Modal from 'components/Modal'
import Form from 'components/Form'
import { useSnackbar } from 'notistack'
import { setInfo, clearInfo } from 'slices/infoSlice'
import { normalizeData } from 'utilities/validator'
import usePopup from 'hooks/usePopup'
import useAxios from 'hooks/useAxios'
import { v4 as uuidv4 } from 'uuid';
import { warpUpFailResponse } from 'utilities/utils'
import useDataHandler from 'hooks/useDataHandler'

export default function AdditionalPrice() {
	const dispatch = useDispatch()
	const { enqueueSnackbar } = useSnackbar();
	const { save } = useDataHandler()
	const info = useSelector(state => state.info.ctx)
	const { post, get, del } = useAxios();
	const [mode, setMode] = useState("initial")
	const { confirmPopup } = usePopup();
	const [allAdditionalPrice, setAllAdditionalPrice] = useState([]);
	const modalId = useMemo(() => uuidv4(), [])
	const roleUser = useSelector(state => state.user.roleName)
	const masterAdditionalPrice = new Set(["เงินเดือน", "ค่าเที่ยวรถ"]);
	const additionalLabel = [
		{ label: "หน้า Driver", value: "driver" },
		{ label: "หน้า Job", value: "job" },
		{ label: "หน้า Payment", value: "payment" },
		{ label: "หน้า Other payment", value: "other payment" },
		{ label: "หน้า Other invoice", value: "other invoice" },
	]

	const fetchData = async controller => {
		const result = await get("/additionalPrice/getAllAdditionalPrice", {}, { signal: controller.signal })
		if (result.status === 200) {
			const data = result.data.data || []
			setAllAdditionalPrice(data)
		}
	}

	useEffect(() => {
		const controller = new AbortController();
		fetchData(controller)
		return () => {
			controller.abort()
		}
	}, [])

	const onCloseModal = useCallback(() => {
		confirmPopup({
			title: "แจ้งเตือน",
			content: "ท่านต้องการยกเลิกการแก้ไขหรือไม่",
			onSubmit: () => {
				setMode("initial")
			}
		})
	}, [])

	const inputForm = [{
		rowData: [
			{
				type: "dropdown",
				required: true,
				props: {
					id: "type",
					label: "ประเภทค่าใช้จ่าย",
					options: additionalLabel,
				}, md: 4
			},
			{
				type: "text",
				required: true,
				props: {
					id: "name",
					label: "ค่าใช้จ่าย",
					readOnly: mode === "edit" && masterAdditionalPrice.has(info.name),
					variant: "outlined"
				}, md: 8
			},
		]
	},
	mode === "edit" && {
		rowData: [
			{
				type: "dropdown",
				props: {
					id: "active",
					label: "สถานะ",
					options: [
						{ label: "ใช้งาน", value: true },
						{ label: "ไม่ใช้งาน", value: false }
					],
				}
			}
		]
	},
	{
		rowData: [
			{
				type: "button",
				props: {
					label: "บันทึก",
					onClick: () => {
						saveData()
					},
					className: "!bg-bpTheme-buttonSubmit"
				}
			}
		]
	}
	]
	const table = useMemo(() => [
		{
			rowData: [{
				type: "dataTable",
				props: {
					columns: [
						{
							id: 'no',
							label: 'เลขที่ค่าใช้จ่าย',
							fields: ["no"]
						},
						{
							id: 'type',
							label: 'ประเภทค่าใช้จ่าย',
							fields: ["type"],
							valuesMap: additionalLabel
						},
						{
							id: 'name',
							label: 'ค่าใช้จ่าย',
							fields: ["name"]
						},
						{
							id: 'active',
							label: 'สถานะ',
							fields: ["active"],
							valuesMap: [{ label: "ใช้งาน", value: true }, { label: "ไม่ใช้งาน", value: false }]

						}
					],
					rows: allAdditionalPrice,
					size: "small",
					showDeleteButton: roleUser === "Owner",
					title: "ข้อมูลค่าใช้จ่ายเพิ่มเติม",
					showSystemFields: true,
					onClick: (e) => {
						setMode("edit")
						dispatch(setInfo(e))
					},
					onDelete: (e, onSuccess) => {
						confirmPopup({
							onSubmit: async () => {
								const result = await del("/additionalPrice/deleteAdditionalPrice", { ids: e.map(data => data.id).join(',') })
								if (result.status === 200) {
									enqueueSnackbar('ลบสำเร็จ', { variant: "success" })
									dispatch(clearInfo())
									await fetchData(new AbortController())
									onSuccess()
								} else {
									enqueueSnackbar('ลบไม่สำเร็จ', { variant: "error" })
								}
							}
						})
					},
					controller: (paging) => get("/additionalPrice/getAllAdditionalPrice", { paging }),
					searchFields: [
						{ label: "ประเภทค่าใช้จ่าย", value: "type" },
						{ label: "ค่าใช้จ่าย", value: "name" },
						{ label: "สถานะ", value: "active" }
					]
				}
			}]
		}, {
			noCol: true,
			rowData: [
				{
					type: "button",
					props: {
						label: "เพิ่มใหม่",
						onClick: () => {
							setMode("create")
							dispatch(clearInfo())
						}
					}
				},
				// {
				// 	type: "upload",
				// 	props: {
				// 		id: "files",
				// 		type: "button",
				// 		className: "!ml-2",
				// 		variant: "outlined",
				// 		maxFiles: 5
				// 	}
				// }
			]
		}
	], [allAdditionalPrice])

	const saveData = useCallback(() => {
		save({
			data: info,
			scope: modalId,
			onSubmit: async () => {
				const data = normalizeData(info)
				let response
				if (mode === "create") {
					response = await post("/additionalPrice/createAdditionalPrice", { ...data, active: true })
				} else if (mode === "edit") {
					response = await post("/additionalPrice/updateAdditionalPrice", { ...data })
				}
				if (response.status === 200) {
					setMode("initial")
					enqueueSnackbar('บันทึกสำเร็จ', { variant: "success" })
					fetchData(new AbortController())
				} else {
					enqueueSnackbar(warpUpFailResponse(response, 'บันทึกไม่สำเร็จ'), { variant: "error" })
				}
			},
			onCancel: () => {
				enqueueSnackbar('ยกเลิกรายการ', { variant: "info" })
			}
		})
	}, [info, mode])

	return (
		<Box>
			<Panel data={table}></Panel>
			<Modal id={modalId} open={mode === "create" || mode === "edit"} onClose={onCloseModal} className="form-modal" contentClassName="min-w-full md:!min-w-[750px]">
				<Form title={"ค่าใช้จ่ายเพิ่มเติม " + (info.no || "")} name="user-form" data={inputForm}></Form>
			</Modal>
		</Box>
	)
}
